var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.375,
    height: 12.375,
    viewBox: "0 0 12.375 12.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.587,13.5h4.894a1.087,1.087,0,0,1,1.087,1.087v4.894a1.087,1.087,0,0,1-1.087,1.087H14.587A1.087,1.087,0,0,1,13.5,19.481V14.587A1.087,1.087,0,0,1,14.587,13.5Z",
    transform: "translate(-9.694 -9.694)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.631,10.069H4.087A1.087,1.087,0,0,1,3,8.981V4.087A1.087,1.087,0,0,1,4.087,3H8.981a1.087,1.087,0,0,1,1.087,1.087v.544",
    transform: "translate(-3 -3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.fc64caf59dd18027b43c37e4a7778703.svg";
export { ForwardRef as ReactComponent };